import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import EPDragHandle from 'editor-components/sidebar/addableComponents/EPDragHandle';
import { DRAG_ICON_BACKGROUND_COLOR } from 'layout-dnd-components/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledView = styled.div.withConfig({
  displayName: "GenericDragPreview__StyledView"
})([".hs-private.hs-private.hs-private &{background-color:", ";block-size:80px;inline-size:80px;border-radius:", ";}"], DRAG_ICON_BACKGROUND_COLOR, ({
  theme
}) => theme.borderRadius[200]);
function GenericDragPreview() {
  return /*#__PURE__*/_jsx(StyledView, {
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "100%",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(EPDragHandle, {
        color: "icon-core-on-fill-default"
      })
    })
  });
}
export default GenericDragPreview;